import { inject, observer } from "mobx-react";
import * as React from "react";
import { IntlProvider } from "react-intl"

import { LocaleStore } from "./LocaleStore";

const mobxIntlProviderChild =  ({locale, children, ...props}: {locale: LocaleStore, children: any}) => {
    const loc = locale.value;
    const messages = locale.messages;
    return <IntlProvider key={loc} locale={loc} messages={messages} {...props}>
        {children}
    </IntlProvider>
}

// tslint:disable-next-line:variable-name
export const MobxIntlProvider = inject("locale")(observer(mobxIntlProviderChild));



// WEBPACK FOOTER //
// ./src/intl/MobxIntlProvider.tsx